import { render, staticRenderFns } from "./integralLack.vue?vue&type=template&id=4c2578ad&scoped=true&"
import script from "./integralLack.vue?vue&type=script&lang=ts&"
export * from "./integralLack.vue?vue&type=script&lang=ts&"
import style0 from "./integralLack.vue?vue&type=style&index=0&id=4c2578ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2578ad",
  null
  
)

export default component.exports